var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "sign_up", class: [_vm.theme, _vm.layout_choice] },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("div", { staticClass: "content" }, [
            _vm.title
              ? _c("h2", {
                  class: { "has-text": _vm.text },
                  domProps: { innerHTML: _vm._s(_vm.title) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.text
              ? _c("div", {
                  staticClass: "sign_up__inner",
                  domProps: { innerHTML: _vm._s(_vm.text) },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _vm.theme === "dark"
        ? _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "341.908",
                height: "250",
                viewBox: "0 0 341.908 250",
              },
            },
            [
              _c("path", {
                attrs: {
                  id: "Path_901",
                  "data-name": "Path 901",
                  d: "M249.2,12.518h92.707v250H0Z",
                  transform: "translate(0 -12.518)",
                  fill: "#16191d",
                },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }